import { useApolloClient } from '@apollo/client'
import { FormattedMessage, useIntl } from 'react-intl'

import List from 'components/v2/List'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { Dropdown } from 'components/v2/Dropdown'
import IconButton from 'components/v2/IconButton'
import { DotsIcon } from 'components/Icons'
import { verticalMessages } from 'features/Companies/components/Vertical/messages'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { GTCompanyV2 } from 'gql/types.generated'
import { resolvers as loginResolvers } from 'resolvers/login'
import { safeFormatMessage } from 'utils/intl'
import { canWrite } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'

export const CompaniesList = ({ companies }: { companies: GTCompanyV2[] }): TSFixMe => {
  const intl = useIntl()
  const client = useApolloClient()
  client.addResolvers(loginResolvers)

  const login = useLogin()

  const hasActions =
    canWrite(FEATURES.COMPANY, login.accessToken.policies) ||
    canWrite(FEATURES.COMPANY_LINE, login.accessToken.policies)

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {hasActions && <Th />}
            <Th>
              <FormattedMessage id="dictionary.name" defaultMessage="Name" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.type" defaultMessage="Type" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.phone" defaultMessage="Phone" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.address" defaultMessage="Address" />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {companies.map((company: TSFixMe): TSFixMe => {
            return (
              <Tr key={company.id}>
                {hasActions && (
                  <Td>
                    <Dropdown
                      toggle={<IconButton icon={<DotsIcon />} noBorder smallPadding />}
                      noPadding
                      noIndicator
                      left
                    >
                      <List.Container>
                        {canWrite(FEATURES.COMPANY, login.accessToken.policies) && (
                          <List.Item noPadding>
                            <List.Link to={`/companies/${company.id}`}>
                              <FormattedMessage id="companies.list.actions.edit" defaultMessage="Edit company" />
                            </List.Link>
                          </List.Item>
                        )}
                        {canWrite(FEATURES.COMPANY_LINE, login.accessToken.policies) && (
                          <List.Item noPadding>
                            <List.Link to={`/lines/new?companyId=${company.id}`}>
                              <FormattedMessage id="companies.list.actions.addLine" defaultMessage="Add line" />
                            </List.Link>
                          </List.Item>
                        )}
                      </List.Container>
                    </Dropdown>
                  </Td>
                )}
                <Td>{company.name}</Td>
                <Td>{safeFormatMessage({ intl, messages: verticalMessages, key: company.vertical })}</Td>
                <Td>{company.phone}</Td>
                <Td>
                  {company.address && (
                    <>
                      <div>{company.address.line1}</div>
                      {company.address.line2 && <div>{company.address.line2}</div>}
                      <div>{`${company.address.zipCode}, ${company.address.cityName} (${company.address.stateCode})`}</div>
                    </>
                  )}
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
